import styled from 'styled-components';
import { Colors } from '../../assets/styles/colors';

export const InputWrapper = styled.div`
  width: 100%;

  .pac-target-input {
    width: 100%;
    border: 1px solid ${Colors.Neutral03};
    background: white;
    border-radius: 4px;
    box-sizing: border-box;
    padding: 12px 8px;
    font-size: 16px;
    color: ${Colors.Neutral05};
  }
`;

export const Label = styled.div`
  color: ${Colors.TextMain};
  font-size: 12px;
  font-weight: 600;

  span {
    color: ${Colors.SemanticErrorMain};
    margin-right: 5px;
  }
`;

export const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;
